<template>
  <el-form-item
    :class="{ 'no-description': !description }"
    :error="error"
    :prop="prop"
    :rules="rules"
  >
    <div v-if="description" class="description" v-html="description"></div>

    <slot></slot>

    <div v-if="hint" class="hint">
      {{ hint }}
    </div>

    <template #label v-if="showLabel">
      <slot name="label">{{ labelText }}</slot>
    </template>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormItem',

  props: {
    prop: {
      type: String,
      required: false
    },

    label: {
      type: String,
      required: false
    },

    description: {
      type: String,
      required: false
    },

    hint: {
      type: String,
      required: false
    },

    rules: {
      type: [Object, Array],
      required: false
    },

    error: {
      type: String,
      required: false
    }
  },
  computed: {
    showLabel() {
      return this.label || this.$slots.label
    },
    labelText() {
      return this.label || ''
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__label {
  color: #5c6374;
  font-size: 14px;
}

>>> .el-form-item__content {
  line-height: unset;
}

.description {
  color: #7e8596;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 8px;
}

.hint {
  color: #7e8596;
  font-size: 12px;
  line-height: 18px;
  margin-top: 8px;
}

.no-description >>> .el-radio-group {
  margin-top: 8px;
}

.no-description >>> .el-radio-group.is-bordered {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/FormItem.vue